const baseCommentContent = `
    commentId
    authorId
    authorName
    content
    headurl
    timestamp
    likedCount
    realLikedCount
    liked
    status
    authorLiked
`;

export const subCommentFragmentContent = `
    ${baseCommentContent}
    replyToUserName
    replyTo
`;

export const commentFragmentContent = `
    ${baseCommentContent}
    subCommentCount
    subCommentsPcursor
    subComments {
        ${subCommentFragmentContent}
    }
`;
